import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { FeatureNotEnabledView } from '@euler/components/entitlements/FeatureNotEnabledView';
import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { StoreFeature } from '@euler/model/enum';
import { Text } from 'react-native';
import { BiDatasetDetailView } from './library/detail/BiDatasetDetailView';

export interface BiDatasetPageParams {
  /** An uploaded dataset id or a built-in model key. */
  datasetRef: string;
}

function BiDataset({ datasetRef }: BiDatasetPageParams) {
  const navigation = useAppNavigation();
  const back = () => navigation.goBack();
  return (
    <BiDatasetDetailView
      datasetRef={datasetRef}
      onBack={back}
      onOpenDashboard={dashboardId =>
        navigation.navigate('BiDashboard', { dashboardId })
      }
      onDeleted={back}
    />
  );
}

export const BiDatasetPage = wrapNavigatorScreen(
  ({ datasetRef }: BiDatasetPageParams) => {
    const profile = useUserProfileInfo();
    const bi = useStoreFeature(StoreFeature.Bi);
    if (!bi.enabled) return <FeatureNotEnabledView feature={StoreFeature.Bi} />;
    if (!profile?.user.enabled)
      return <Text>当前门店尚未开通经营分析，或账号不可用。</Text>;
    return (
      <BiDataset
        key={`${profile.org.id}:${profile.store.id}:${datasetRef}`}
        datasetRef={datasetRef}
      />
    );
  },
  { title: '数据', headerShown: false, headerMode: 'float' },
);
